module.exports = "/assets/data/2c137d7cfa753a87cc3d8960986bce17-IG11.data.json";